/* Trade Engraving - search overlay + predictive suggestions */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  var dialog = overlay.querySelector('[data-search-dialog]');
  var input = overlay.querySelector('[data-search-input]');
  var form = overlay.querySelector('[data-search-form]');
  var results = overlay.querySelector('[data-search-results]');
  var idle = overlay.querySelector('[data-search-idle]');
  var meta = overlay.querySelector('[data-search-meta]');
  var statusEl = overlay.querySelector('[data-search-status]');
  var clearBtn = overlay.querySelector('[data-search-clear]');
  var openBtns = document.querySelectorAll('[data-search-open]');
  var closeEls = overlay.querySelectorAll('[data-search-close]');
  var predictiveUrl = overlay.getAttribute('data-predictive-url') || '/search/suggest';

  var previouslyFocused = null;
  var debounceTimer = null;
  var abortController = null;
  var activeIndex = -1;
  var DEBOUNCE_MS = 220;
  var MIN_CHARS = 2;

  function isOpen() {
    return overlay.getAttribute('aria-hidden') === 'false';
  }

  function getFocusable() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]):not([hidden]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null && !el.hasAttribute('hidden');
    });
  }

  function setOpenButtons(expanded) {
    openBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function openSearch() {
    if (isOpen()) {
      input.focus();
      return;
    }

    // Close the mobile nav if it's open so body scroll lock stays consistent.
    var mobileDrawer = document.querySelector('[data-drawer]');
    if (mobileDrawer && mobileDrawer.getAttribute('aria-hidden') === 'false') {
      mobileDrawer.setAttribute('aria-hidden', 'true');
      var drawerToggle = document.querySelector('[data-drawer-open]');
      if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'false');
    }

    previouslyFocused = document.activeElement;
    overlay.setAttribute('aria-hidden', 'false');
    setOpenButtons(true);
    document.body.style.overflow = 'hidden';
    window.requestAnimationFrame(function () {
      input.focus();
      var len = input.value.length;
      try {
        input.setSelectionRange(len, len);
      } catch (_) { /* search inputs may reject selection in some browsers */ }
    });
    if (input.value.trim().length >= MIN_CHARS) {
      fetchSuggestions(input.value.trim());
    }
  }

  function closeSearch() {
    if (!isOpen()) return;
    overlay.setAttribute('aria-hidden', 'true');
    setOpenButtons(false);
    document.body.style.overflow = '';
    clearActiveOption();
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function setClearVisibility() {
    if (!clearBtn) return;
    clearBtn.hidden = input.value.length === 0;
  }

  function showIdle() {
    if (idle) idle.hidden = false;
    results.hidden = true;
    results.innerHTML = '';
    if (meta) meta.hidden = true;
    overlay.classList.remove('is-loading');
    activeIndex = -1;
  }

  function setStatus(text) {
    if (!meta || !statusEl) return;
    statusEl.textContent = text || '';
    meta.hidden = !text;
  }

  function optionNodes() {
    return Array.prototype.slice.call(
      results.querySelectorAll('.predictive-search__item, .predictive-search__all')
    );
  }

  function clearActiveOption() {
    optionNodes().forEach(function (el) {
      el.classList.remove('is-active');
    });
    activeIndex = -1;
  }

  function setActiveOption(index) {
    var options = optionNodes();
    if (!options.length) {
      activeIndex = -1;
      return;
    }
    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;
    clearActiveOption();
    activeIndex = index;
    options[activeIndex].classList.add('is-active');
    options[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  function extractSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('#shopify-section-predictive-search') ||
      doc.querySelector('[id^="shopify-section-"]') ||
      doc.body;
    var inner = section.querySelector('#predictive-search-results');
    return inner ? inner.outerHTML : (section.innerHTML || '');
  }

  function fetchSuggestions(query) {
    if (abortController) abortController.abort();
    abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

    overlay.classList.add('is-loading');
    setStatus('Searching…');

    var params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection,page,article',
      'resources[limit]': '8',
      'resources[limit_scope]': 'each',
      section_id: 'predictive-search'
    });

    var opts = abortController ? { signal: abortController.signal } : {};

    fetch(predictiveUrl + '?' + params.toString(), opts)
      .then(function (res) {
        if (!res.ok) throw new Error('Predictive search failed');
        return res.text();
      })
      .then(function (html) {
        var markup = extractSectionHtml(html);
        if (idle) idle.hidden = true;
        results.hidden = false;
        results.innerHTML = markup || '<p class="predictive-search__empty">No matches found.</p>';
        overlay.classList.remove('is-loading');

        var countNode = results.querySelector('[data-predictive-count]');
        var count = countNode ? Number(countNode.getAttribute('data-predictive-count') || 0) : 0;
        if (count > 0) {
          setStatus(count + (count === 1 ? ' suggestion' : ' suggestions'));
        } else {
          setStatus('No suggestions');
        }
        activeIndex = -1;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        overlay.classList.remove('is-loading');
        if (idle) idle.hidden = true;
        results.hidden = false;
        results.innerHTML =
          '<p class="predictive-search__empty">Suggestions unavailable. Press Enter to search.</p>';
        setStatus('Suggestions unavailable');
      });
  }

  function onInput() {
    setClearVisibility();
    var query = input.value.trim();
    window.clearTimeout(debounceTimer);

    if (query.length < MIN_CHARS) {
      if (abortController) abortController.abort();
      showIdle();
      return;
    }

    debounceTimer = window.setTimeout(function () {
      fetchSuggestions(query);
    }, DEBOUNCE_MS);
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeSearch();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      setClearVisibility();
      showIdle();
      input.focus();
    });
  }

  input.addEventListener('input', onInput);

  form.addEventListener('submit', function (e) {
    var options = optionNodes();
    if (activeIndex >= 0 && options[activeIndex]) {
      e.preventDefault();
      options[activeIndex].click();
      return;
    }
    if (!input.value.trim()) {
      e.preventDefault();
      input.focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      if (isOpen()) closeSearch();
      else openSearch();
      return;
    }

    if (!isOpen()) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeSearch();
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveOption(activeIndex + 1);
      return;
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveOption(activeIndex - 1);
      return;
    }

    if (e.key === 'Tab' && dialog) {
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  setClearVisibility();
  showIdle();
})();
